import { useState, useEffect, useMemo } from "react";
import { Select, TreeSelect, Checkbox, Input, Radio } from "antd";
import Services from "../../../network/Services";
import { isNullUndefine } from "../../../control/Constant";

const PreferredProfessional = ({ onProfessionalChange, submitClicked}) => {
  const [specialty, setSelectSpecialty] = useState('1');
  const [selectedProType, setSelectedProType] = useState([]);
  const [subCategory, setSubCategory] = useState([]);

  const [professionalTypeList, setProfessionalTypeList] = useState([]);
  const [professionalSubTypeList, setProfessionalSubTypeList] = useState([]);

  const [otherProTypeText, setOtherProTypeText] = useState("");
  const [otherPhysicianText, setOtherPhysicianText] = useState("");
  const [otherSpecialistText, setOtherSpecialistText] = useState("");
  const [proTypeError, setProTypeError] = useState("");

  const OTHER_ID = "999999";
  const PHYSICIAN_ID = "10";
  const SPECIALIST_ID = "11";

  // ================= FETCH =================


  useEffect(() => {

    setSelectedProType([]);
    setSubCategory([]);
    Services.getProfessionalType(specialty)
      .then((res) => {
        setProfessionalTypeList(res?.data?.data || []);
      }).catch((err) => {
  console.error("API Error:", err);
});
  }, [specialty]);

  useEffect(() => {
    if (!professionalSubTypeList || professionalSubTypeList.length === 0) {
      Services.getProfessionalSubType()
        .then((res) => {
          setProfessionalSubTypeList(res?.data?.data || []);
        })
              .catch((err) => {
  console.error("API Error:", err);
});
    }
  }, []);

    const buildProfessionalJson = () => {
    const OTHER_ID = "999999";

    let proCategories = [];

    // 1️⃣ Add all subCategory (3rd dropdown)
    // subCategory.forEach((val) => {
    //   const [typeId, subTypeId] = val.split("-");
    //   proCategories.push({
    //     proSerDescId: Number(specialty),
    //     proTypeId: Number(typeId),
    //     proSubTypeId: Number(subTypeId),
    //     proCatId: 0,
    //   });
    // });
      subCategory.forEach((val) => {
        if (!val || typeof val !== "string") return;
        const [typeId, subTypeId] = val.split("-");
        if (!typeId) return;
        proCategories.push({
          proSerDescId: Number(specialty),
          proTypeId: Number(typeId),
          proSubTypeId: subTypeId ? Number(subTypeId) : null,
          proCatId: 0,
        });
      });

    // 2️⃣ Add parent types WITHOUT subtypes
    selectedProType.forEach((typeId) => {
      const hasSubType = subCategory.some((val) =>
        val.startsWith(`${typeId}-`)
      );

      if (!hasSubType && typeId !== OTHER_ID) {
        proCategories.push({
          proSerDescId: Number(specialty),
          proTypeId: Number(typeId),
          proSubTypeId: null,
          proCatId: 0,
        });
      }
    });

    // 3️⃣ Add global "Other" (2nd dropdown)
    if (selectedProType.includes(OTHER_ID)) {
      proCategories.push({
        proSerDescId: Number(specialty),
        proTypeId: Number(OTHER_ID),
        proSubTypeId: null,
        proCatId: 0,
      });
    }
    const USER_ID = sessionStorage.getItem("loggedUserId") || '';

    return {
      proUserId: 0,
      userId: null,
      isGenAuth: true,
      isStatus: true,
      isActive: true,
      upsertedBy: USER_ID,
      proCategories,
      businessName: "",
      businessTypeId: null,
    };
  };


  const buildCreateOthersPayload = () => {
    const CREATED_BY = sessionStorage.getItem("loggedUserId") || '';
    const CATEGORY_ID = 28;
    const OTHER_ID = "999999";

    let payload = [];

    // GLOBAL OTHER
    if (selectedProType.includes(OTHER_ID) && otherProTypeText?.trim()) {
      payload.push({
        othersCategoryId: CATEGORY_ID,
        othersName: otherProTypeText.trim(),
        createdBy: CREATED_BY,
        isActive: true,

        // 🔥 ADD THIS (NO STRING TYPE)
        proTypeId: Number(OTHER_ID),
        proSubTypeId: null,
      });
    }

    // PHYSICIAN OTHER
    if (
      subCategory.includes(`10-${OTHER_ID}`) &&
      otherPhysicianText?.trim()
    ) {
      payload.push({
        othersCategoryId: CATEGORY_ID,
        othersName: otherPhysicianText.trim(),
        createdBy: CREATED_BY,
        isActive: true,

        proTypeId: 10,
        proSubTypeId: Number(OTHER_ID),
      });
    }

    // SPECIALIST OTHER
    if (
      subCategory.includes(`11-${OTHER_ID}`) &&
      otherSpecialistText?.trim()
    ) {
      payload.push({
        othersCategoryId: CATEGORY_ID,
        othersName: otherSpecialistText.trim(),
        createdBy: CREATED_BY,
        isActive: true,
        proTypeId: 11,
        proSubTypeId: Number(OTHER_ID),
      });
    }

    return payload;
  };


  const payload = useMemo(() => {
  return {
    main: buildProfessionalJson(),
    others: buildCreateOthersPayload(),
    otherMeta: {
      otherProTypeText,
      otherPhysicianText,
      otherSpecialistText,
    },
  };
}, [selectedProType, subCategory, specialty, otherProTypeText, otherPhysicianText, otherSpecialistText]);



useEffect(() => {
  onProfessionalChange?.(payload);
}, [payload, onProfessionalChange]);

  useEffect(() => {
    if (submitClicked && selectedProType.length === 0) {
      setProTypeError("Service Provider is required");
    }
  }, [submitClicked, selectedProType]);

  // ================= SUB TYPE =================
  const subTypeOptions = useMemo(() => {
    if (!selectedProType?.length) return [];

    let result = [];

    const filtered = professionalSubTypeList?.filter((item) =>
      selectedProType.includes(String(item.proTypeId))
    );

    result = filtered.map((item) => ({
      title: item.proSubType,
      value: `${item.proTypeId}-${item.proSubTypeId}`,
      typeId: String(item.proTypeId),
    }));

    // Inject "Other" for Physician
    if (selectedProType.includes(PHYSICIAN_ID)) {
      const exists = result.some(
        (item) => item.value === `${PHYSICIAN_ID}-${OTHER_ID}`
      );

      if (!exists) {
        result.push({
          title: "Other",
          value: `${PHYSICIAN_ID}-${OTHER_ID}`,
          typeId: PHYSICIAN_ID,
        });
      }
    }

    // Sort "Other" on top per group
    result.sort((a, b) => {
      if (a.typeId !== b.typeId) return 0;
      if (a.title === "Other") return -1;
      if (b.title === "Other") return 1;
      return a.title.localeCompare(b.title);
    });

    return result;
  }, [selectedProType, professionalSubTypeList]);

  // ================= TREE DATA =================
  const treeData = useMemo(() => {
    const map = {};

    subTypeOptions.forEach((item) => {
      if (!map[item.typeId]) map[item.typeId] = [];
      map[item.typeId].push(item);
    });

    return Object.entries(map).map(([typeId, items]) => ({
      title:
        typeId === PHYSICIAN_ID
          ? `Physician (${items.length})`
          : `Specialist (${items.length})`,
      value: typeId,
      selectable: false,
      children: items,
    }));
  }, [subTypeOptions]);

  // ================= HANDLER =================
  const handleSelectChange = (value, type) => {

    if (type === "selectedProType") {
      setSelectedProType(value || []);
      setSubCategory([]);
      // 🔥 CLEAR ERROR WHEN USER SELECTS
      if (value && value.length > 0) {
        setProTypeError("");
      }
    }

    if (type === "subCategory") {
      setSubCategory(value || []);
    }
  };





  return (
    <div style={{ width: "100%", marginTop: ".5rem" }}>

      {/* ===== YOUR EXISTING STYLES (UNCHANGED) ===== */}


      <style>
        {`
.select-wrapper .ant-select-selector {
  border: 1px solid #333333 !important;
}

.select-wrapper .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border: 1px solid #333333 !important;
}

.select-wrapper .ant-select-focused .ant-select-selector,
.select-wrapper .ant-select-open .ant-select-selector {
  border: 1px solid #333333 !important;
  box-shadow: none !important;
}

.custom-tree-inline .ant-select-tree-node-content-wrapper {
  display: flex;
  align-items: center;
}

.custom-tree-inline .ant-select-tree-checkbox {
  margin-right: 8px;
}

.custom-tree-inline .ant-select-tree-indent {
  display: none;
}

.custom-tree-inline .ant-select-tree-treenode {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

.custom-tree-inline .ant-select-tree-checkbox-inner {
  border-color: #d9d9d9 !important;
  background-color: #fff !important;
}

.custom-tree-inline 
.ant-select-tree-checkbox:hover 
.ant-select-tree-checkbox-inner {
  border-color: #8B0000 !important;
}

.custom-tree-inline 
.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner {
  border-color: #8B0000 !important;
  box-shadow: none !important;
}

.custom-tree-inline 
.ant-select-tree-checkbox-checked 
.ant-select-tree-checkbox-inner {
  background-color: #8B0000 !important;
  border-color: #8B0000 !important;
}

.custom-tree-inline 
.ant-select-tree-checkbox-indeterminate 
.ant-select-tree-checkbox-inner {
  background-color: #8B0000 !important;
  border-color: #8B0000 !important;
}

.custom-tree-inline 
.ant-select-tree-checkbox-indeterminate 
.ant-select-tree-checkbox-inner::after {
  background-color: #fff !important;
}

.custom-tree-inline 
.ant-select-tree-checkbox-checked 
.ant-select-tree-checkbox-inner::after {
  border-color: #fff !important;
}

/* ===== OTHER INPUT STYLE ONLY ===== */
.ant-input::placeholder {
  color: #333333 !important;
  opacity: 1;
}

/* only affect "Other" inputs */
input[placeholder*="Other"] {
  border: 1px solid #333333 !important;
}

/* focus */
input[placeholder*="Other"]:focus {
  border: 1px solid #333333 !important;
  box-shadow: none !important;
}

/* ===== 🔥 FIX INPUT HEIGHT TO MATCH SELECT ===== */
.ant-input {
  height: 40px !important;
  padding: 4px 11px !important;
  line-height: 22px !important;
  box-sizing: border-box;
}

/* if any input wrapped (future safe) */
.ant-input-affix-wrapper {
  height: 40px !important;
  padding: 0 11px !important;
  display: flex;
  align-items: center;
}
  .ant-select-multiple .ant-select-selection-item{
   height: 32px !important;
  }
 .ant-select-arrow {
 color : #333 !important;
 }  

.custom-radio .ant-radio {
  margin-right: 10px;
}

.custom-radio .ant-radio-wrapper:first-child .ant-radio {
  margin-left: 0px;
}

`}
      </style>

      {/* SPECIALTY */}

      <div className="select-wrapper custom-radio mb-2">
        <label style={{ marginBottom: 8, display: "block", fontWeight: "bold" }}>
          Select Specialty *
        </label>
        <Radio.Group
          value={specialty}
          onChange={(e) => setSelectSpecialty(e.target.value)}
        >
          <Radio value="1">Health</Radio>
          <Radio value="2">Housing</Radio>
          <Radio value="3">Finance</Radio>
          <Radio value="4">Legal</Radio>
          <Radio value="5">Other</Radio>
        </Radio.Group>
      </div>

      {/* SERVICE PROVIDER */}
      {!isNullUndefine(specialty) && (
        <div className="select-wrapper">
          <Select
            mode="multiple"
            placeholder="Select Service Provider"
            value={selectedProType}
            onChange={(val) => handleSelectChange(val, "selectedProType")}
            style={{ width: "100%", marginBottom: 12 }}
            optionLabelProp="label"   // 🔥 VERY IMPORTANT
            filterOption={(input, option) =>
              (option?.label || "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {professionalTypeList?.map((item) => (
              <Select.Option
                key={item.value}
                value={String(item.value)}
                label={item.label}   // ✅ only this goes into input
              >
                <Checkbox
                  checked={selectedProType.includes(String(item.value))}
                  style={{ pointerEvents: "none", marginRight: 8 }}
                />
                {item.label}
              </Select.Option>
            ))}
          </Select>
          {proTypeError && (
            <div style={{ color: "red", fontSize: 14 }}>
              {proTypeError}
            </div>
          )}

        </div>
      )}

      {/* SUB SERVICE PROVIDER */}
      {subTypeOptions.length > 0 && (
        <div className="select-wrapper">
          {/* <TreeSelect
            dropdownClassName="custom-tree-inline"
            treeData={treeData}
            value={subCategory}
            onChange={(val) => handleSelectChange(val, "subCategory")}
            treeCheckable
            showCheckedStrategy={TreeSelect.SHOW_CHILD}
            placeholder="Select Sub Service Provider"
            style={{ width: "100%" }}
            showSearch
            maxTagCount={2}
            maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
          /> */}
          <TreeSelect
            dropdownClassName="custom-tree-inline"
            treeData={treeData}
            value={subCategory}
            onChange={(val) => handleSelectChange(val, "subCategory")}
            treeCheckable
            showCheckedStrategy={TreeSelect.SHOW_CHILD}
            placeholder="Select Sub Service Provider"
            style={{ width: "100%" }}

            // ✅ Search enabled
            showSearch
            treeNodeFilterProp="title"
            filterTreeNode={(input, treeNode) =>
              (treeNode.title || "").toLowerCase().includes(input.toLowerCase())
            }

            // ✅ UI controls
            maxTagCount={2}
            maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
          />
        </div>
      )}

      {/* ===== ✅ FIXED OTHER INPUTS ===== */}

      {selectedProType?.includes(OTHER_ID) && (
        <Input
          placeholder="Other Description"
          value={otherProTypeText}
          onChange={(e) => setOtherProTypeText(e.target.value)}
          style={{ marginTop: 10 }}
        />
      )}

      {subCategory?.includes(`${PHYSICIAN_ID}-${OTHER_ID}`) && (
        <Input
          placeholder="Physician Other Description"
          value={otherPhysicianText}
          onChange={(e) => setOtherPhysicianText(e.target.value)}
          style={{ marginTop: 10 }}
        />
      )}

      {subCategory?.includes(`${SPECIALIST_ID}-${OTHER_ID}`) && (
        <Input
          placeholder="Specialist Other Description"
          value={otherSpecialistText}
          onChange={(e) => setOtherSpecialistText(e.target.value)}
          style={{ marginTop: 10 }}
        />
      )}
    </div>
  );
};

export default PreferredProfessional;